export default "__VITE_ASSET__BbUMa2x2__"